import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getProjectBySlug } from "../../API/Projects/projectsService";
import { CalendarClock } from "lucide-react";
import { Button } from "../../components/ui/button";

const TravauxSinglePage = () => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
  const { id } = useParams();
  const [data, setData] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const data = await getProjectBySlug(id);

        setData(data);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  console.log(data)

  const extractPdfLink = (html: string) => {
    const urlMatch = html.match(/href=["']([^"']+\.pdf)["']/i);
    if (urlMatch) return urlMatch[1];

    const base64Match = html.match(
      /href=["'](data:application\/pdf;base64,[^"']+)["']/i
    );
    return base64Match ? base64Match[1] : null;
  };

  const pdfUrl = data?.news?.description
    ? extractPdfLink(data?.news?.description || "")
    : null;

  const removePdfLinks = (html: string) => {
    return html.replace(
      /<a[^>]+href=["'](data:application\/pdf;base64,[^"']+)["'][^>]*>.*?<\/a>/gi,
      ""
    );
  };

  return (
    <div className="mt-10">
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div className="mt-5">
          <h1 className="text-2xl font-bold text-black">
            {data?.projects?.title || "Titre"}
          </h1>
          <div className="flex mt-2 space-x-3">
            <div className="text-primary">
              {data?.projects?.date
                ? new Date(data.news.date).toLocaleDateString("fr-FR", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })
                : new Date().toLocaleDateString("fr-FR")}
            </div>
          </div>

         </div>

        {/* News Image */}
        {data?.projects?.image && (
          <div className="mt-5">
            <img src={`${uploadUrl}/projects/${data.projects.image}`} alt="" />
          </div>
        )}

        {/* News Description */}
        <div className="mt-10">
          {data?.projects?.description && (
            <div
              dangerouslySetInnerHTML={{
                __html: removePdfLinks(data.projects.description),
              }}
            />
          )}
        </div>

        {pdfUrl && (
          <div className="mt-4">
            <a
              href={pdfUrl}
              download="document.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 "
            >
              📄 Télécharger le document PDF
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default TravauxSinglePage;
